'use strict'
import APIS from "@/apis";
import {getPlatform} from '@/lib/units'
import stat from '@/frontend-lib/lib/stat/Stat.js'

class TRACKER {
    constructor({channelId = null, channemName = '未获取到渠道信息',internalChannelText = '内部渠道'} = {}) {
        this.channelId = this.setChannelId(channelId * 1);
        this.channelName = channemName;
        this.platform = getPlatform();
        this.runtime = 'wechat';
        this.internalChannelText = internalChannelText
        this.publicZhugeStat = null
        this.setRuntime();
        console.log(`埋点的平台是: ${this.runtime}`);
        this.initPublicZhuge()
        this.initZhuge();
    }

    initZhuge() {
        window.zhuge = window.zhuge || [];
        window.zhuge.methods = "_init debug identify track trackLink trackForm page".split(" ");
        window.zhuge.factory = function (b) {
            return function () {
                var a = Array.prototype.slice.call(arguments);
                a.unshift(b);
                window.zhuge[b.indexOf('init') == -1 ? 'push' : 'unshift'](a); // 由于诸葛io异步加载，命令的调用顺序变为非固定，但是要保证init指令先执行 --@by cyc
                return window.zhuge;
            }
        };
        for (var i = 0; i < window.zhuge.methods.length; i++) {
            var key = window.zhuge.methods[i];
            window.zhuge[key] = window.zhuge.factory(key);
        }
        window.zhuge.load = function (b, x) {
            if (!document.getElementById("zhuge-js")) {
                var a = document.createElement("script");
                var verDate = new Date();
                var verStr = verDate.getFullYear().toString() + verDate.getMonth().toString() + verDate.getDate().toString();

                a.type = "text/javascript";
                a.id = "zhuge-js";
                a.async = !0;
                a.src = (location.protocol == 'http:' ? "http://sdk.zhugeio.com/zhuge.min.js?v=": 'https://zgsdk.zhugeio.com/zhuge.min.js?v=') + verStr;
                var c = document.getElementsByTagName("script")[0];
                c.parentNode.insertBefore(a, c);
                window.zhuge._init(b, x)
            }
        };

        // 异步加载zhugeio
        // 诸葛IO，this app key is use for app
        // 根据 IS_PRODUCTION 开启是否debug，不用每次都进行开关
        // appkey :f6f19cec54894af8990714a597fc09f4
        // m站key：be2579193b754fd2900f660a0093fa62
        // 微站key：954fc7ea2885479cae96792800783191
        let zhugeKey = '954fc7ea2885479cae96792800783191';
        if(this.runtime === 'app') {
            zhugeKey = 'f6f19cec54894af8990714a597fc09f4';
        } else if (this.runtime === 'msite') {
            zhugeKey = 'be2579193b754fd2900f660a0093fa62';
        }

        console.log({debug: (IS_PRODUCTION && (APIS.env==''))?false : true}, this.runtime);
        window.zhuge.load(zhugeKey, {debug: (IS_PRODUCTION && (APIS.env==''))?false : true});

    }
    initPublicZhuge() {
        if (this.runtime == "app") {
            this.publicZhugeStat = new stat()
        }
    }
    setChannelName(name) {
        this.channelName = name;
    }
    setInternalChannel(state) {
        this.internalChannelText = !!state?'内部渠道':'外部部渠道'
    }

    setChannelId(id) {
        this.channelId = id;
        if([513, 514].includes(id)) {
            this.setChannelName(id===513?'壹心理M站': '壹心理APP');
        }
    }

    setRuntime() {
        if(this.platform.isYixinliApp || this.channelId === 514) {
            this.runtime = 'app';
        } else if ( !(this.platform.isYixinliApp || this.platform.isWechat) || this.channelId === 513 ) {
            this.runtime = 'msite';
        }
    }

    // 下面是事件
    indexTestSwiper(testName, indexTagType) {
        let eventName = '';
        if (indexTagType == 'new') {
            eventName = '点击最新';
        }
        if (indexTagType == 'hot') {
            eventName = '点击最热';
        }
        zhuge.track(eventName, {
            '渠道': this.channelName,
            '渠道ID': this.channelId,
            '题目名称': testName,
        });
    }

    indexBannerClick(index, testName) {
        zhuge.track('点击焦点图', {
            '渠道': this.channelName,
            '渠道ID': this.channelId,
            '位置': index + 1,
            '题目名称': testName
        })
    }

    sharePage(pageName, testName, testId) {
        let eventName = `分享`;
        if(this.runtime !== 'wechat') {
            eventName = `v5100_测评-${eventName}`
        }
        const params = {
            '分享内容': pageName,
            '渠道ID': this.channelId,
            '渠道': this.channelName,
        }
        if (testName) params['测试名称'] = testName
        if (testId) params['测试ID'] = testId
        zhuge.track(eventName, params)
    }

    sortSetType(sortType, sortBy) {
        let eventName = `访问分类页栏目`;
        if(this.runtime !== 'wechat') {
            eventName = `v5100_测评-${eventName}`
        }
        zhuge.track(eventName, {
            '渠道': this.channelName,
            '渠道ID': this.channelId,
            '栏目': sortType,
            '排序方式': sortBy
        })
    }

    sortFilterSwitch(sortType, sortBy) {
        let eventName = `切换排序方式`;
        if(this.runtime !== 'wechat') {
            eventName = `v5100_测评-${eventName}`
        }
        zhuge.track(eventName, {
            '渠道': this.channelName,
            '渠道ID': this.channelId,
            '栏目': sortType,
            '排序方式': sortBy
        })
    }

    payTest(testName) {
        let eventName = `点击立即支付`;
        if(this.runtime !== 'wechat') {
            eventName = `v5100_测评-${eventName}`
        }
        zhuge.track(eventName, {
            '渠道': this.channelName,
            '渠道ID': this.channelId,
            '测评名称': testName,
        });
    }

    answerStartTest(testTitle, startFrom) {
        let eventName = '开始测试';
        if(this.runtime !== 'wechat') {
            eventName = `v5100_测评-${eventName}`
        }
        zhuge.track(eventName, {
            '渠道': this.channelName,
            '渠道ID': this.channelId,
            '题目名称': testTitle,
            '开始位置': startFrom
        });
    }

    answerOvertime(testName) {
        let eventName = '超时未完成';
        if(this.runtime !== 'wechat') {
            eventName = `v5100_测评-${eventName}`
        }
        zhuge.track(eventName, {
            '渠道': this.channelName,
            '渠道ID': this.channelId,
            '题目名称': testName,
        });
    }

    answerGiveUp(testName) {
        let eventName = '中途放弃';
        if(this.runtime !== 'wechat') {
            eventName = `v5100_测评-${eventName}`
        }
        zhuge.track(eventName, {
            '渠道': this.channelName,
            '渠道ID': this.channelId,
            '题目名称': testName,
        });
    }

    answerProgress(testName, progress) {
        let eventName = '新答题情况';
        if(this.runtime !== 'wechat') {
            eventName = `v5100_测评-${eventName}`
        }
        zhuge.track(eventName, {
            '渠道': this.channelName,
            '渠道ID': this.channelId,
            '题目名称': testName,
            '答题进度': progress
        });
    }

    answerSubmit(testName) {
        let eventName = '提交测试';
        if(this.runtime !== 'wechat') {
            eventName = `v5100_测评-${eventName}`
        }
        zhuge.track(eventName, {
            '渠道': this.channelName,
            '渠道ID': this.channelId,
            '题目名称': testName,
        });
    }

    reviewReport() {
        let eventName = '重复查看报告';
        if(this.runtime !== 'wechat') {
            eventName = `v5100_测评-${eventName}`
        }
        zhuge.track(eventName, {
            '渠道': this.channelName,
            '渠道ID': this.channelId,
        });
    }

    viewSharedReport(testName) {
        let eventName = '访问报告分享页（无浏览时长）';
        if(this.runtime !== 'wechat') {
            eventName = `v5100_测评-${eventName}`
        }
        zhuge.track(eventName, {
            '渠道': this.channelName,
            '渠道ID': this.channelId,
            '题目名称': testName
        });
    }

    shareReport(testName) {
        let eventName = '点击报告页分享按钮';
        if(this.runtime !== 'wechat') {
            eventName = `v5100_测评-${eventName}`
        }
        zhuge.track(eventName, {
            '渠道': this.channelName,
            '渠道ID': this.channelId,
            '题目名称': testName
        });
    }

    shareReportinS(testName) {
        let eventName = '点击报告页晒一晒按钮';
        if(this.runtime !== 'wechat') {
            eventName = `v5100_测评-${eventName}`
        }
        zhuge.track(eventName, {
            '渠道': this.channelName,
            '渠道ID': this.channelId,
            '题目名称': testName
        });
    }

    shareReportSuccess(testName) {
        let eventName = '报告页分享成功';
        if(this.runtime !== 'wechat') {
            eventName = `v5100_测评-${eventName}`
        }
        zhuge.track(eventName, {
            '渠道': this.channelName,
            '渠道ID': this.channelId,
            '题目名称': testName
        });
    }

    reportSend2Email(testName) {
        let eventName = '发送报告到邮箱';
        if(this.runtime !== 'wechat') {
            eventName = `v5100_测评-${eventName}`
        }
        zhuge.track(eventName, {
            '渠道': this.channelName,
            '渠道ID': this.channelId,
            '题目名称': testName
        });
    }

    pageView(pageName, fromPage, Options) {
        console.log(`访问${pageName}`);
        let eventName = `访问${pageName}`;
        if(this.runtime !== 'wechat') {
            eventName = `v5100_测评-${eventName}`
        }
        zhuge.track(eventName, Object.assign({
            '渠道': this.channelName,
            '渠道ID': this.channelId,
            '页面来源': fromPage,
        }, Options))
    }

    pageLeave(pageName, toPage, Options) {
        console.log(`离开${pageName}`);
        let eventName = `离开${pageName}`;
        if(this.runtime !== 'wechat') {
            eventName = `v5100_测评-${eventName}`
        }
        zhuge.track(eventName, Object.assign({
            '渠道': this.channelName,
            '渠道ID': this.channelId,
            '前往页面': toPage
        }, Options))
    }

    searchClickSuggest(Options) {
        // 点击搜索建议，可能是 关键词 或者 热门搜索
        let eventName = `点击搜索建议`;
        if(this.runtime !== 'wechat') {
            eventName = `v5100_测评-${eventName}`
        }
        zhuge.track(eventName, Object.assign({
            '渠道': this.channelName,
            '渠道ID': this.channelId,
        }, Options));
    }

    searchUserWord(word) {
        // 用户搜索【自己输入】的词
        let eventName = '搜索内容';
        if(this.runtime !== 'wechat') {
            eventName = `v5100_测评-${eventName}`
        }
        zhuge.track(eventName, {
            '渠道': this.channelName,
            '渠道ID': this.channelId,
            '关键词': word
        });
    }

    eventViewReport({from, testName}) {
        let eventName = `查看报告`;
        if(this.runtime !== 'wechat') {
            eventName = `v5100_测评-${eventName}`
        }
        // 用户点击查看报告的一刹那
        zhuge.track(eventName, {
            '渠道': this.channelName,
            '渠道ID': this.channelId,
            '题目名称': testName,
            '来源': from
        });
    }

    clickDetailRecomend({toTestName, fromTestName}) {
        // 点击测评详情页的大家都在测
        let eventName = '点击测评详情页-推荐';
        if(this.runtime !== 'wechat') {
            eventName = `v5100_测评-${eventName}`
        }
        zhuge.track(eventName, {
            '渠道': this.channelName,
            '渠道ID': this.channelId,
            '来源题目': fromTestName,
            '访问题目': toTestName,
        });
    }

    clickShareRecomend({toTestName, fromTestName}) {
        let eventName = `点击报告分享页-推荐`;
        if(this.runtime !== 'wechat') {
            eventName = `v5100_测评-${eventName}`
        }
        // 报告分享页的大家都要测被点击的时候
        zhuge.track(eventName, {
            '渠道': this.channelName,
            '渠道ID': this.channelId,
            '来源题目': fromTestName,
            '访问题目': toTestName,
        });
    }

    clickShareMeToo(testName) {
        let eventName = `点击报告分享页-我也要测`;
        if(this.runtime !== 'wechat') {
            eventName = `v5100_测评-${eventName}`
        }
        // 报告分享页的我也要测被点击的时候
        zhuge.track(eventName, {
            '渠道': this.channelName,
            '渠道ID': this.channelId,
            '题目名称': testName,
        });
    }

    clickReportRecomend({toTestName, fromTestName}) {
        let eventName = `点击报告页-推荐`;
        if(this.runtime !== 'wechat') {
            eventName = `v5100_测评-${eventName}`
        }
        // 报告页的推荐被点击的时候
        zhuge.track(eventName, {
            '渠道': this.channelName,
            '渠道ID': this.channelId,
            '来源题目': fromTestName,
            '访问题目': toTestName,
        });
    }

    mineDotest(testName) {
        // 点击我的测评-去测试
        let eventName = `点击我的测评-去测试`;
        if(this.runtime !== 'wechat') {
            eventName = `v5100_测评-${eventName}`
        }
        zhuge.track(eventName, {
            '渠道': this.channelName,
            '渠道ID':this.channelId,
            '题目名称': testName,
        })
    }

    minePublishComment(testName){
        let eventName = `点击我的测评-发表评价`;
        if(this.runtime !== 'wechat') {
            eventName = `v5100_测评-${eventName}`
        }
        // 点击 我的测评-发表评价
        zhuge.track(eventName, {
            '渠道': this.channelName,
            '渠道ID':this.channelId,
            '测评名称': testName,
        })
    }
    commentAnonymous({testName, anonymous}) {
        let eventName = `选择匿名评价`;
        if(this.runtime !== 'wechat') {
            eventName = `v5100_测评-${eventName}`
        }
        // 点击 评价成功-接着评价
        zhuge.track(eventName, {
            '渠道': this.channelName,
            '渠道ID':this.channelId,
            '测评名称': testName,
            '是否匿名': !!anonymous? '是': '否',
        })
    }

    commentSuccessPublishComment(testName){
        let eventName = `点击评价成功-去评价`;
        if(this.runtime !== 'wechat') {
            eventName = `v5100_测评-${eventName}`
        }
        // 点击 评价成功-接着评价
        zhuge.track(eventName, {
            '渠道': this.channelName,
            '渠道ID':this.channelId,
            '测评名称': testName,
        })
    }

    reportPublishComment(testName){
        let eventName = `点击发表评价按钮`;
        if(this.runtime !== 'wechat') {
            eventName = `v5100_测评-${eventName}`
        }
        // 点击 报告页 发表评价按钮
        zhuge.track(eventName, {
            '渠道': this.channelName,
            '渠道ID':this.channelId,
            '测评名称': testName,
        })
    }

    reportViewComment(testName){
        let eventName = `点击查看评价按钮`;
        if(this.runtime !== 'wechat') {
            eventName = `v5100_测评-${eventName}`
        }
        // 点击 报告页 查看评价按钮
        zhuge.track(eventName, {
            '渠道': this.channelName,
            '渠道ID':this.channelId,
            '测评名称': testName,
        })
    }

    deleteComment(testName) {
        let eventName = `删除评价`;
        if(this.runtime !== 'wechat') {
            eventName = `v5100_测评-${eventName}`
        }
        // 点击 查看我的评价页 确认删除评价按钮
        zhuge.track(eventName, {
            '渠道': this.channelName,
            '渠道ID':this.channelId,
            '测评名称': testName,
        })
    }

    commentShareScale(testName){
        let eventName = `推荐测评给好友`;
        if(this.runtime !== 'wechat') {
            eventName = `v5100_测评-${eventName}`
        }
        // 评价成功页 推荐测评给好友，分享成功时触发
        zhuge.track(eventName, {
            '渠道': this.channelName,
            '渠道ID':this.channelId,
            '测评名称': testName,
        })
    }

    commentSubmitFail(testName){
        let eventName = `评价失败`;
        if(this.runtime !== 'wechat') {
            eventName = `v5100_测评-${eventName}`
        }
        // 评价失败，分享成功时触发
        zhuge.track(eventName, {
            '渠道': this.channelName,
            '渠道ID':this.channelId,
            '测评名称': testName,
        })
    }

    detail_viewAllComment(testName){
        // 详情页-查看全部评论
        let eventName = `详情页-查看全部评论`;
        if(this.runtime !== 'wechat') {
            eventName = `v5100_测评-${eventName}`
        }
        zhuge.track(eventName, {
            '渠道': this.channelName,
            '渠道ID':this.channelId,
            '测评名称': testName,
        })
    }

    commentSuccess_viewAllComment(testName) {
        let eventName = `评价成功-查看全部评论`;
        if(this.runtime !== 'wechat') {
            eventName = `v5100_测评-${eventName}`
        }
        // 评价成功-查看全部评论
        zhuge.track(eventName, {
            '渠道': this.channelName,
            '渠道ID': this.channelId,
            '测评名称': testName,
        })
    }

    commentSuccess_recommendClicked(testName){
        let eventName = `点击发表成功页-猜你想测`;
        if(this.runtime !== 'wechat') {
            eventName = `v5100_测评-${eventName}`
        }
        // 评价成功-查看全部评论
        zhuge.track(eventName, {
            '渠道': this.channelName,
            '渠道ID': this.channelId,
            '测评名称': testName,
        })
    }

    detail_clickGift(testName){
        // 详情页-点击赠送他人按钮
        let eventName = `点击"赠送他人"按钮`;
        if(this.runtime !== 'wechat') {
            eventName = `v5100_测评-${eventName}`
        }
        zhuge.track(eventName, {
            '渠道': this.channelName,
            '渠道ID': this.channelId,
            '测评名称': testName,
        })
    }

    gift_paySuccess({testName, buyNUmber}){
        // 购买赠礼成功
        let eventName = `购买赠礼成功`;
        if(this.runtime !== 'wechat') {
            eventName = `v5100_测评-${eventName}`
        }
        zhuge.track(eventName, {
            '渠道': this.channelName,
            '渠道ID': this.channelId,
            '测评名称': testName,
            '份数': buyNUmber
        })
    }

    gift_shareSuccess(testName){
        // 赠送好友成功
        zhuge.track('赠送好友成功', {
            '渠道': this.channelName,
            '渠道ID': this.channelId,
            '测评名称': testName,
        })
    }

    gift_click_receiveGift(testName){
        // 点击“立即领取”按钮
        zhuge.track('点击“立即领取”按钮', {
            '渠道': this.channelName,
            '渠道ID': this.channelId,
            '测评名称': testName,
        })
    }

    gift_click_startGiftTest(testName){
        // 点击“已领取！开始测试”
        zhuge.track('点击“已领取！开始测试”', {
            '渠道': this.channelName,
            '渠道ID': this.channelId,
            '测评名称': testName,
        })
    }

    gift_click_goShare(testName){
        // 点击“待赠”按钮
        zhuge.track('点击“待赠”按钮”', {
            '渠道': this.channelName,
            '渠道ID': this.channelId,
            '测评名称': testName,
        })
    }

    gift_mine_goTest(testName){
        // 点击“赠礼管理”-“去测试”
        zhuge.track('点击“赠礼管理”-“去测试”', {
            '渠道': this.channelName,
            '渠道ID': this.channelId,
            '测评名称': testName,
        })
    }

    gift_mine_goReport(testName){
        // 点击“赠礼管理”-“查看报告”
        zhuge.track('点击“赠礼管理”-“查看报告”', {
            '渠道': this.channelName,
            '渠道ID': this.channelId,
            '测评名称': testName,
        })
    }
    gift_mine_empty_viewMore(){
        // 点击“赠礼管理”-“去看看”
        zhuge.track('点击“赠礼管理”-“去看看”', {
            '渠道': this.channelName,
            '渠道ID': this.channelId,
        })
    }
    shareReport_Img(testName){
        console.log(testName);
       // 点击保存图片事件
        zhuge.track('点击保存图片事件', {
            '渠道ID': this.channelId,
            '渠道': this.channelName,
            '测评名称': testName
        })
    }

    reportADclick(testName) {
        let eventName = `点击报告页广告`;
        if(this.runtime !== 'wechat') {
            eventName = `v5100_测评-${eventName}`
        }
        // 点击报告页广告
        zhuge.track(eventName, {
            '渠道ID': this.channelId,
            '渠道': this.channelName,
            '测评名称': testName
        })
    }

    save_Collect(name){
        console.log(name);
       // 点击收藏按钮
        zhuge.track('点击“收藏按”钮', {
            '渠道ID': this.channelId,
            '渠道': this.channelName,
            '测评名称': name
        })
    }

    up_Collect(name){
        console.log(name);
       // 点击取消收藏按钮
        zhuge.track('点击取消收藏按钮', {
            '渠道ID': this.channelId,
            '渠道': this.channelName,
            '测评名称': name
        })
    }

    on_myCollect(name){
        console.log(name);
       // 我的测评-点击-“收藏”列表
        zhuge.track('我的测评-点击“收藏”列表', {
        })
    }

    on_mytrack(name){
        console.log(name);
       // 访问“我的足迹”页
        zhuge.track('访问“我的足迹”页', {
            '渠道ID': this.channelId,
            '渠道': this.channelName
        })
    }
    edit_mytrack(name){
        console.log(name);
       // 足迹页-点击“编辑”按钮
        zhuge.track('足迹页-点击“编辑”按钮', {
            '渠道ID': this.channelId,
            '渠道': this.channelName
        })
    }
    del_mytrack(name){
        console.log(name);
       // 足迹页-点击“删除”按钮
        zhuge.track('足迹页-点击“删除”按钮', {
            '渠道ID': this.channelId,
            '渠道': this.channelName
        })
    }

    all_Sel_mytrack(name){
        console.log(name);
       // 足迹页-点击“全选”按钮
        zhuge.track('足迹页-点击“全选”按钮', {
            '渠道ID': this.channelId,
            '渠道': this.channelName
        })
    }

    reportADclick_qingshu(testName){
        // 点击报告倾诉业务广告
        zhuge.track("推荐倾诉业务", {
            '渠道ID': this.channelId,
            '渠道': this.channelName,
            '测评名称': testName
        })
    }
    // 测试添加pdf数据

    report_onremoval(name){
        // 点击报告迁移服务
        zhuge.track('点击报告迁移服务', {
            '测评名称': name,
        })
    }
    report_onremoval_pdf(name){
        // 点击迁移弹窗-PDF报告
        zhuge.track('点击迁移弹窗-PDF报告', {
            '测评名称': name,
        })
    }
    report_commit_pdf(name){
        // 选中迁移弹窗-PDF报告 点击“确认迁移”后统计
        zhuge.track('选中迁移弹窗-PDF报告', {
            '测评名称': name,
        })
    }
    report_onremoval_book(name){
        // 点击迁移弹窗-纸质报告
        zhuge.track('点击迁移弹窗-纸质报告', {
            '测评名称': name,
        })
    }
    report_commit_book(name){
        // 选中迁移弹窗-纸质报告 点击“确认迁移”后统计
        zhuge.track('选中迁移弹窗-纸质报告', {
            '测评名称': name,
        })
    }
    report_close_email(name){
        // 点击迁移弹窗-关闭弹窗
        zhuge.track('点击迁移弹窗-关闭弹窗', {
            '测评名称': name,
        })
    }

    report_on_del(name){
        // 点击迁移弹窗-测后即焚
        zhuge.track('点击迁移弹窗-测后即焚', {
            '测评名称': name,
        })
    }
    report_commit_opendel(name){
        // 开启迁移弹窗-测后即焚 点击“确认迁移”后统计
        zhuge.track('开启迁移弹窗-测后即焚', {
            '测评名称': name,
        })
    }
    report_commit_del(name){
        // 关闭迁移弹窗-测后即焚 点击“确认迁移”后统计
        zhuge.track('关闭迁移弹窗-测后即焚', {
            '测评名称': name,
        })
    }

    report_commit_email(name){
        // 点击迁移弹窗-确认迁移
        zhuge.track('点击迁移弹窗-确认迁移', {
            '测评名称': name,
        })
    }

    report_send_email(name){
        // 确认发送报告到邮箱
        zhuge.track('确认发送报告到邮箱', {
            '测评名称': name,
        })
    }

    onclick_readingReport(name){
        // 点击报告解读按钮
        zhuge.track('点击报告解读按钮', {
            '测评名称': name,
        })
    }

    readingReport_callOn(name){
        // 点击接通报告解读师按钮
        zhuge.track('点击接通报告解读师按钮', {
            '测评名称': name,
        })
    }

    readingReport_inOk(name){
        // 点击解读繁忙弹窗-好的
        zhuge.track('点击解读繁忙弹窗-好的', {
            '测评名称': name,
        })
    }

    goInto_readingReport(name){
        // 访问解读报告页
        zhuge.track('访问解读报告页', {
            '测评名称': name,
        })
    }

    leave_readingReport(initTime,leaveTime,onTime,go,name){
        // 离开解读报告页  （访问时间，离开时间，浏览时间， 前往页面， 测评名称）
        zhuge.track('点击接通报告解读师按钮', {
            '测评名称': name,
        })
    }
    // 双十一定金页面
    go_dingjin_btn(){
        // 点击“预售定金GO”按钮
        zhuge.track('点击“预售定金GO”按钮', {
            '渠道名称': this.channelName,
        })
    }
    go_dingjin_cancel(){
        // 点击“定金-我再想想”按钮
        zhuge.track('点击“定金-我再想想”按钮', {
            '渠道名称': this.channelName,
        })
    }
    go_dingjin_confrim(){
        // 点击“定金-确认下单”按钮
        zhuge.track('点击“定金-确认下单”按钮', {
            '渠道名称': this.channelName,
        })
    }
    go_dingjin_getback(){
        // 点击“回到主会场”按钮
        zhuge.track('点击“回到主会场”按钮', {
            '渠道名称': this.channelName,
        })
    }
    go_dingjin_getTest(){
        // 点击“查看全部测试”按钮
        zhuge.track('点击“查看全部测试”按钮', {
            '渠道名称': this.channelName,
        })
    }
    go_dingjin_suss(){
        // 访问“定金预付成功”页
        zhuge.track('访问“定金预付成功”页', {
            '渠道名称': this.channelName,
        })
    }
    go_into_active11(){
        // 点击双11活动入口
        zhuge.track('点击双11活动入口', {
            '渠道名称': this.channelName,
        })
    }
    go_promotion490_btn(){
        // 点击“4.9季卡-去抢”按钮
        zhuge.track('点击“4.9季卡-去抢”按钮', {
            '渠道名称': this.channelName,
        })
    }
    go_promotion3800_btn(){
        // 点击“38年卡-去抢”按钮
        zhuge.track('点击“38年卡-去抢”按钮', {
            '渠道名称': this.channelName,
        })
    }
    go_promotion1990_btn(){
        // 点击“19.9季卡-去抢”按钮
        zhuge.track('点击“19.9季卡-去抢”按钮', {
            '渠道名称': this.channelName,
        })
    }
    go_promotion1_emotion_btn(){
        // 点击“情感套餐包”按钮
        zhuge.track('点击“情感套餐包”按钮', {
            '渠道名称': this.channelName,
        })
    }
    go_promotion_work_btn(){
        // 点击“职场套餐包”按钮
        zhuge.track('点击“职场套餐包”按钮', {
            '渠道名称': this.channelName,
        })
    }
    go_promotion_health_btn(){
        // 点击“健康套餐包”按钮
        zhuge.track('点击“健康套餐包”按钮', {
            '渠道名称': this.channelName,
        })
    }
    go_promotion_all_btn(){
        // 点击“全部测评”按钮
        zhuge.track('点击“全部测评”按钮', {
            '渠道名称': this.channelName,
        })
    }
    go_promotion_today_pay(typeName){
        // 访问“今日必抢-确认付款”弹窗
        zhuge.track('访问“今日必抢-确认付款”弹窗', {
            '渠道名称': this.channelName,
            '券包类型':  typeName
        })
    }
    go_promotion_category_pay(){
        // 访问“品类包-确认付款”弹窗
        zhuge.track('访问“品类包-确认付款”弹窗', {
            '渠道名称': this.channelName,
        })
    }
    go_promotion_category_payin(typeName){
        // 点击“品类包-立即支付”按钮
        zhuge.track('点击“品类包-立即支付”按钮', {
            '渠道名称': this.channelName,
            '券包类型': typeName
        })
    }
    go_promotion_category_phonenum(typeName){
        // 点击“填写手机号码”
        zhuge.track('点击“填写手机号码”', {
            '渠道名称': this.channelName,
            '券包类型': typeName
        })
    }
    go_promotion_taday_canvalpay(typeName){
        // 点击“今日必抢-确认付款-关闭”按钮
        zhuge.track('点击“今日必抢-确认付款-关闭”按钮', {
            '渠道名称': this.channelName,
            '券包类型': typeName
        })
    }
    go_promotion_category_canvalpay(typeName){
        // 套餐包-确认付款-关闭
        zhuge.track('套餐包-确认付款-关闭', {
            '渠道名称': this.channelName,
            '券包类型': typeName
        })
    }


    // 晒一晒需求
    click_show_share(name){
        console.log(name);
       // 晒一晒页面-点击晒一晒心声按钮
        zhuge.track('点击晒一晒-心声按钮', {
            '测评名称': name,
            '渠道名称': this.channelName
        })
    }

    click_bg_share(name){
        console.log(name);
       // 晒一晒页面-点击晒一晒背景按钮
        zhuge.track('点击晒一晒-背景按钮', {
            '测评名称': name,
            '渠道名称': this.channelName
        })
    }

    click_challenge_share(name){
        console.log(name);
       // 晒一晒页面-点击晒一晒挑战语按钮
        zhuge.track('点击晒一晒-挑战语按钮', {
            '测评名称': name,
            '渠道名称': this.channelName
        })
    }

    click_go_share(name){
        console.log(name);
       // 晒一晒页面-点击晒一晒-去晒按钮
        zhuge.track('点击晒一晒-去晒按钮', {
            '测评名称': name,
            '渠道名称': this.channelName
        })
    }

    click_vocie_go(name){
       // 晒一晒页面-点击落地页-立刻购买按钮
        zhuge.track('点击落地页-立刻购买按钮', {
            '测评名称': name,
            '渠道名称': this.channelName
        })
    }

    vipPageView(pageName, fromPage, Options) {
        console.log(`高端产品-访问${pageName}`);
        let eventName = `访问${pageName}`;
        zhuge.track(eventName, Object.assign({
            '渠道': this.channelName,
            '渠道ID': this.channelId,
            '页面来源': fromPage
        }, Options))
    }

    newPageView(activtyName, pageName, Options){
        console.log(this.channelConfig)
        zhuge.track(`${activtyName}-页面访问`, Object.assign({
            '渠道': this.channelName,
            '渠道ID': this.channelId,
            '页面名称': pageName,
            '渠道来源': this.internalChannelText
        }, Options))
    }

    // 抑郁单品点击事件
    depressionClick (element) {
        zhuge.track('抑郁单品-点击事件', {
            '点击元素': element,
            '渠道名称': this.channelName,
            '渠道ID': this.channelId
        })
    }

    // 抑郁单品支付事件
    depressionPay (type) {
        zhuge.track('抑郁单品-支付事件', {
            '支付类型': type,
            '渠道名称': this.channelName,
            '渠道ID': this.channelId
        })
    }

    // 分享测评社区
    shareCommunity (testId) {
        zhuge.track('测评社区-交互行为', {
            '对象': '一键分享按钮',
            '测评ID': testId,
            '渠道名称': this.channelName,
            '渠道ID': this.channelId
        })
    }

    // 会员升级2020
    vipPageEvent2020 (pageName) {
        zhuge.track('会员升级2020--页面访问', {
            '页面名称': pageName,
            '渠道ID': this.channelId,
            '来源域名': location.hostname
        })
    }

    vipInteraction2020 (target, text='', behavior='点击') {
        zhuge.track('会员升级2020--交互行为', {
            '行为': behavior,
            '对象': target,
            '被点击的元素文字': text,
            '渠道ID': this.channelId,
            '来源域名': location.hostname,
        })
    }

     importCommonConsult(target, text='', behavior='点击') {
        if (this.platform.isYixinliApp || this.channelId === 514 ) {
            // 2021.04.15 配合咨询统一形式导咨询埋点
            this.publicZhugeStat.send({
                name:'常规导咨询--交互行为',
                properties:{
                    '行为': behavior,
                    '对象': target,
                    '被点击的元素文字': text,
                    '渠道ID': this.channelId,
                    '来源域名': location.hostname,
                }
            })
        }else{
            zhuge.track('常规导咨询--交互行为', {
                '行为': behavior,
                '对象': target,
                '被点击的元素文字': text,
                '渠道ID': this.channelId,
                '来源域名': location.hostname,
            })
        }
    }

    vipPageEventSyk (pageName) {
        zhuge.track('生涯卡-页面访问', {
            '页面名称': pageName,
            '渠道ID': this.channelId,
            '来源域名': location.hostname
        })
    }


    importCommonSyk(target, text='', behavior='点击') {
      zhuge.track('生涯卡-交互行为', {
        '行为': behavior,
        '对象': target,
        '被点击的元素文字': text,
        '渠道ID': this.channelId,
        '来源域名': location.hostname,
      })
    }

    toutiaoClick(target, text='', behavior='点击') {
        zhuge.track('抖音小程序--交互行为', {
            '行为': behavior,
            '对象': target,
            '被点击的元素文字': text,
            '渠道ID': this.channelId,
            '来源域名': location.hostname,
        })
    }
}

export {
  TRACKER
}



// WEBPACK FOOTER //
// ./src/lib/zhugeTrack.js